function e(e){return{messageList:e.messageList}}export{e as default};
